import { ResponsiveDialog, ResponsiveDialogFooter } from "@/components/responsive-dialog";
import { Button } from "@/components/ui/button";

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  destructiveLabel: string;
  onDestructive: () => void;
  safeLabel: string;
  onSafe: () => void;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  destructiveLabel,
  onDestructive,
  safeLabel,
  onSafe,
}: ConfirmDialogProps) {
  return (
    <ResponsiveDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
    >
      <ResponsiveDialogFooter>
        <Button variant="danger-soft" onClick={onDestructive}>
          {destructiveLabel}
        </Button>
        <Button variant="primary" onClick={onSafe} autoFocus>
          {safeLabel}
        </Button>
      </ResponsiveDialogFooter>
    </ResponsiveDialog>
  );
}
